/*eslint-disable*/
import api from '../'

class diadaGameItems {
    // POST: couples
    static getItemsByRequest (params) {
        return api.axios.get('/diada/items', { params }).then(response => response.data.items);
    }
}

export default diadaGameItems;
